import {
  SET_MOBILE_MENU_OPEN,
  SET_ONBOARDING_CHECK_PENDING,
  SET_REDIRECT_PATH,
  SET_THEME_MODE,
  ThemeModeEnum,
} from "_constants";

export const setRedirectPath = (redirectPath = null) => {
  return (dispatch) => {
    dispatch({ type: SET_REDIRECT_PATH, payload: redirectPath });
  };
};

export const setMobileMenuOpen = (payload = false) => {
  return (dispatch) => {
    dispatch({ type: SET_MOBILE_MENU_OPEN, payload });
  };
};

export const setThemeMode = (payload = ThemeModeEnum.DARK) => {
  return (dispatch) => {
    dispatch({ type: SET_THEME_MODE, payload });
  };
};

export const setOnboardingCheckPending = (payload = false) => {
  return (dispatch) => {
    dispatch({ type: SET_ONBOARDING_CHECK_PENDING, payload });
  };
};
